enum MonthYearDisplayMode {
    MonthAndYear,
    Year
}

export default MonthYearDisplayMode;
